import ParameterErrors from '../errors/ParameterErrors';
import Validation from '../validation/Validation';
const { throwNotOfType } = ParameterErrors;
export default class Vector3 {
    constructor(props) {
        const { x, y, z } = props;
        if (!Validation.isNumber(x)) throwNotOfType("x", "number");
        if (!Validation.isNumber(y)) throwNotOfType("y", "number");
        if (!Validation.isNumber(z)) throwNotOfType("z", "number");
        this._x = x;
        this._y = y;
        this._z = z;
		this.toArray = this.toArray.bind(this);
    }
    get x() {
        return this._x;
    }
    get y() {
        return this._y;
    }
    get z() {
        return this._z;
    }
	toArray(){
		return [this._x, this._y, this._z];
	}
    static fromArray(arr) {
        return new Vector3({
            x: arr[0],
            y: arr[1],
            z: arr[2]
        });
    }
    static fromObj(obj) {
        return new Vector3(obj);
    }
}
